import script from "./CamposPermitidos.vue?vue&type=script&setup=true&lang=js"
export * from "./CamposPermitidos.vue?vue&type=script&setup=true&lang=js"

import "./CamposPermitidos.vue?vue&type=style&index=0&id=2e307208&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e307208"]])

export default __exports__